<template>
    <div class="text-center">
        <canvas id="canvas" height="300" width="300" style="display: block; width: 300px; height: 300px;" class="chartjs-render-monitor p-2 mb-3"></canvas>
        <div class="wellness-center-block">
            <span class="wellness-points">{{points}}</span><br/>
            <span class="wellness-footer">points earned</span>
        </div>
    </div>
</template>

<script>
    export default {
        props:['chartdata', 'chartcolors','chartlabels','points'],
        mounted() {
            var ctx=document.getElementById('canvas').getContext('2d');
            new Chart(ctx, {
                type: 'doughnut',
                data: {
                    datasets: [{
                        data: this.chartdata,
                        borderWidth: 0,
                        backgroundColor: this.chartcolors
                    }],

                    // These labels appear in the legend and in the tooltips when hovering different arcs
                    labels: this.chartlabels
                },
                options: {
                    // Here is where we enable the 'radiusBackground'
                    radiusBackground: {
                        color: '#d1d1d1' // Set your color per instance if you like
                    },
                    cutoutPercentage: 50,
                    title: {
                        display: false,
                    },
                    legend: {
                        display: false,
                    },
                    tooltips:{
                        displayColors:false,
                        callbacks: {
                            label: function(tooltipItem, data) {
                                console.log(tooltipItem);
                                console.log(data);

                                return data.labels[tooltipItem.index];
                            },

                        }
                    }
                }
            });
        },

    }
</script>
